import moment from "moment";

export function _formatMoney(str) {
  if (str) {
    return str.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }
  return 0;
}

export function _formatDayNoHour(str) {
  if (str) {
    return moment(str).format("DD/MM/YYYY");
  }
  return "";
}

export function getParamUrlByKey(key) {
  let search = window.location.search;
  let arr = search.split("?");
  let params = new URLSearchParams(arr[1]);
  let res;
  if (key) {
    res = params.get(key);
  }
  return res;
}
